import { priceStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPrice";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import merge from "lodash/merge";
import { css } from "styled-components";

// TODO: ISA REFACTOR
merge(priceStyles, {
    productPrice: {
        price: {
            priceText: { size: 21 },
            unitOfMeasureText: {
                size: 20,
                css: css`
                    font-weight: bold;
                `,
            },
        },
        wrapper: {
            css: css`
                width: 100% !important;
                display: inline-block !important;
            `,
        },
    },
});
